import { render, staticRenderFns } from "./createswitchmodel.vue?vue&type=template&id=40773d08&"
import script from "./createswitchmodel.vue?vue&type=script&lang=ts&"
export * from "./createswitchmodel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createswitchmodel.vue"
export default component.exports